export default function Grid({ children, extraClass = "" }) {
  return (
    <div
      className={`grid grid-cols-4 640:grid-cols-6 1024:grid-cols-12 gap-16 640:gap-20 1024:gap-24 ${extraClass}`}
    >
      {children}
    </div>
  );
}
